/**
 * Runtime environment detector for Moji.
 * Routes push notification and install logic per platform.
 */

export function isCapacitorNative() {
  return typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() === true;
}

export function isIOS() {
  if (typeof window === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
}

export function isStandalonePWA() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    window.navigator.standalone === true
  );
}

export function iOSVersion() {
  if (!isIOS()) return null;
  const m = window.navigator.userAgent.match(/OS (\d+)_(\d+)(?:_(\d+))?/);
  if (!m) return null;
  return { major: parseInt(m[1], 10), minor: parseInt(m[2], 10) };
}

export function supportsWebPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    return false;
  }
  if (isIOS()) {
    const v = iOSVersion();
    if (!v) return false;
    if (v.major < 16 || (v.major === 16 && v.minor < 4)) return false;
    // iOS 16.4+ only supports web push when the PWA is installed to home screen
    return isStandalonePWA();
  }
  return true;
}

export function pushEnvironment() {
  if (isCapacitorNative()) return 'native';
  if (supportsWebPush()) return 'web-push';
  if (isIOS() && !isStandalonePWA()) return 'ios-needs-install';
  return 'unsupported';
}
